import {Component, OnInit} from '@angular/core';
import PerfectScrollbar from 'perfect-scrollbar';
import {AngularFireAuth} from '@angular/fire/auth';
import {AngularFirestore} from '@angular/fire/firestore';
import {AuthService} from '../services/auth.service';

declare const $: any;

// Metadata
export interface RouteInfo {
    path: string;
    title: string;
    type: string;
    icontype: string;
    collapse?: string;
    children?: ChildrenItems[];
}

export interface ChildrenItems {
    path: string;
    title: string;
    ab: string;
    type?: string;
}

// Menu Items
export const ROUTES: RouteInfo[] = [
//   {
//     path: '/dashboard',
//     title: 'Dashboard',
//     type: 'link',
//     icontype: 'dashboard'
// },


    // {
//     path: '/components',
//     title: 'Components',
//     type: 'sub',
//     icontype: 'apps',
//     collapse: 'components',
//     children: [
//         {path: 'buttons', title: 'Buttons', ab: 'B'},
//         {path: 'grid', title: 'Grid System', ab: 'GS'},
//         {path: 'panels', title: 'Panels', ab: 'P'},
//         {path: 'sweet-alert', title: 'Sweet Alert', ab: 'SA'},
//         {path: 'notifications', title: 'Notifications', ab: 'N'},
//         {path: 'icons', title: 'Icons', ab: 'I'},
//         {path: 'typography', title: 'Typography', ab: 'T'}
//     ]
// }, {
//     path: '/forms',
//     title: 'Forms',
//     type: 'sub',
//     icontype: 'content_paste',
//     collapse: 'forms',
//     children: [
//         {path: 'regular', title: 'Regular Forms', ab: 'RF'},
//         {path: 'extended', title: 'Extended Forms', ab: 'EF'},
//         {path: 'validation', title: 'Validation Forms', ab: 'VF'},
//         {path: 'wizard', title: 'Wizard', ab: 'W'}
//     ]
// }, {
//     path: '/tables',
//     title: 'Tables',
//     type: 'sub',
//     icontype: 'grid_on',
//     collapse: 'tables',
//     children: [
//         {path: 'regular', title: 'Regular Tables', ab: 'RT'},
//         {path: 'extended', title: 'Extended Tables', ab: 'ET'},
//         {path: 'datatables.net', title: 'Datatables.net', ab: 'DT'}
//     ]
// }, {
//     path: '/maps',
//     title: 'Maps',
//     type: 'sub',
//     icontype: 'place',
//     collapse: 'maps',
//     children: [
//         {path: 'google', title: 'Google Maps', ab: 'GM'},
//         {path: 'fullscreen', title: 'Full Screen Map', ab: 'FSM'},
//         {path: 'vector', title: 'Vector Map', ab: 'VM'}
//     ]
// }, {
//     path: '/widgets',
//     title: 'Widgets',
//     type: 'link',
//     icontype: 'widgets'
//
// }, {
//     path: '/charts',
//     title: 'Charts',
//     type: 'link',
//     icontype: 'timeline'
//
// }, {
//     path: '/calendar',
//     title: 'Calendar',
//     type: 'link',
//     icontype: 'date_range'
// }, {
//     path: '/pages',
//     title: 'Pages',
//     type: 'sub',
//     icontype: 'image',
//     collapse: 'pages',
//     children: [
//         {path: 'pricing', title: 'Pricing', ab: 'P'},
//         {path: 'timeline', title: 'Timeline Page', ab: 'TP'},
//         {path: 'login', title: 'Login Page', ab: 'LP'},
//         {path: 'register', title: 'Register Page', ab: 'RP'},
//         {path: 'lock', title: 'Lock Screen Page', ab: 'LSP'},
//         {path: 'user', title: 'User Page', ab: 'UP'}
//     ]
// },


    {
        path: '/admin',
        title: 'Admin',
        type: 'sub',
        icontype: 'grid_on',
        collapse: 'admin',
        children: [
            {path: 'users', title: 'Users', ab: 'U'},
        ]
    }, {
        path: '/posts',
        title: 'Posts',
        type: 'sub',
        icontype: 'image',
        collapse: 'posts',
        children: [
            {path: 'list', title: 'List Posts', ab: 'LP'},
            // {path: 'new', title: 'New Post', ab: 'NP'}
        ]
    }, {
        path: '/surveys',
        title: 'Surveys',
        type: 'sub',
        icontype: 'image',
        collapse: 'surveys',
        children: [
            {path: 'list', title: 'List Surveys', ab: 'LS'},
            {path: 'new', title: 'New Survey', ab: 'NS'}
        ]
    }, {
        path: '/adverts',
        title: 'Adverts',
        type: 'sub',
        icontype: 'image',
        collapse: 'advert',
        children: [
            {path: 'list', title: 'Old List Adverts', ab: 'OLA'},
            {path: 'newList', title: 'New List Adverts', ab: 'NLA'},
            {path: 'old', title: 'Old Advert', ab: 'OA'},
            {path: 'new', title: 'New Advert', ab: 'NA'}
        ]
    }
];

@Component({
    selector: 'app-sidebar-cmp',
    templateUrl: 'sidebar.component.html',
})

export class SidebarComponent implements OnInit {
    public menuItems: any[];
    public currentUser: any;

    constructor(public afAuth: AngularFireAuth, private afs: AngularFirestore, private authService: AuthService) {
        this.afAuth.authState.subscribe(value => {
            console.log(value);
        });
    }

    isMobileMenu() {
        if ($(window).width() > 991) {
            return false;
        }
        return true;
    }

    ngOnInit() {
        this.menuItems = ROUTES.filter(menuItem => menuItem);

        // const uid = (this.afAuth.auth.currentUser as any).uid;
        // this.afs.doc<any>(`users/${uid}`).valueChanges().subscribe(value => {
        //     this.currentUser = value;
        //     console.log(this.currentUser);
        // });

        this.currentUser = this.authService.getCurrentUser();
    }

    updatePS(): void {
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            const elemSidebar = <HTMLElement>document.querySelector('.sidebar .sidebar-wrapper');
            const ps = new PerfectScrollbar(elemSidebar, {wheelSpeed: 2, suppressScrollX: true});
        }
    }

    isMac(): boolean {
        let bool = false;
        if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 || navigator.platform.toUpperCase().indexOf('IPAD') >= 0) {
            bool = true;
        }
        return bool;
    }
}
